module.exports = __webpack_public_path__ + "img/simple-light.19fdc39c.png";